import { render, staticRenderFns } from "./helpOTP.vue?vue&type=template&id=f5e8c8fe&scoped=true&lang=pug&"
import script from "./helpOTP.vue?vue&type=script&lang=js&"
export * from "./helpOTP.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=f5e8c8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e8c8fe",
  null
  
)

export default component.exports